import { render, staticRenderFns } from "./NumberItem.vue?vue&type=template&id=64c3418d&scoped=true"
import script from "./NumberItem.vue?vue&type=script&lang=ts"
export * from "./NumberItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3418d",
  null
  
)

export default component.exports